export default class heroVideo {
    constructor() {

        // const heroSectionSubpage = document.querySelector('.hero-section-subpage');
        // const heroPrelabelContainer = document.querySelector('.hero-section-subpage__prelabel-container');
        const heroMediaWrapper = document.querySelector('.hero-section-subpage__media-wrapper');

        function placePlaybutton() {
            const btnVideoContainer = document.querySelector('.hero-section-subpage .btn-video-container');
            heroMediaWrapper.prepend(btnVideoContainer);
        }

        placePlaybutton();
        window.addEventListener('resize', placePlaybutton);
    }
}
